const data = {
  title: 'Entry Steps',
  sections: [
    {
      title: 'Welcome',
      steps: [
        {
          component: 'StartKit',
          config: {},
        },
      ],
    },
    {
      title: 'Kit Verification',
      steps: [
        {
          component: 'VerifyLegacyBox',
          config: {},
        },
      ],
    },
  ],
}

export default data
